import React, {Component} from 'react';
import del from "../resources/images/estrategas/tools/trash.png";
import edit from "../resources/images/estrategas/tools/edit.svg";
import * as Request from "../service/data-info-chart/requestsUtil";
import { DELETE_NEW, SAVE_NEW, UPDATE_IMAGE_NEW, UPDATE_NEW } from "../utils/constants";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Input } from 'reactstrap';


class ListNews extends Component{
  addImage = event => {
    const file = event.target.files[0];
    const fd = new FormData();

    if (file !== undefined) {
      fd.append('file', file);
      this.setState({ image: fd });
    }
  };

  constructor(props) {
    super(props);
    this.deleteNews = this.deleteNews.bind(this);
    this.toggleDelete = this.toggleDelete.bind(this);
    this.edit = this.edit.bind(this);
    this.toggleEdit = this.toggleEdit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.state={ modalDelete: false, modalEdit: false, title: this.props.data.title,
      body: this.props.data.body, image: '' }
  }

  toggleDelete(){
    this.setState({ modalDelete: !this.state.modalDelete });
  }

  deleteNews(idNew){
    Request.getFetch(DELETE_NEW + idNew).then(()=>{


      this.setState({ modalDelete: !this.state.modalDelete });
      this.props.callbackFromParent();
    })
  }

  toggleEdit(){
    this.setState({ modalEdit: !this.state.modalEdit });
  }

  edit(idNew){

    const config = {
      headers: {
        'content-type': 'multipart/form-data'
      }
    };

    let fd = new FormData();
    let fdImage = this.state.image;


    if(this.state.image!==''){
      fdImage.append('id', idNew);
      Request.postFetch2(UPDATE_IMAGE_NEW, fdImage, config)
        .then(resp => {
          this.props.callbackFromParent();
        });
    }

    fd.append('id', idNew);
    fd.append('title', this.state.title);
    fd.append('body', this.state.body);

    Request.postFetch2(UPDATE_NEW, fd, config)
      .then(() => {
        this.props.callbackFromParent();
      });
  }

  handleChange(evt) {
    const target = evt.target;
    const name = target.name;
    const value = target.value;
    this.setState({ [name]: value });
  }

  render() {
    return (
      <div className='row pt-3'>
        <div className='col-6 col-lg-8 news-list-title'>{this.props.data.title}</div>
        <div className='col-3 col-lg-2'>{this.props.data.dateRegister}</div>
        <Modal size={'lg'} isOpen={this.state.modalEdit} toggle={this.toggleEdit}>
          <ModalHeader className='header-modal'
                       toggle={this.toggleEdit}>Noticias</ModalHeader>
          <ModalBody>
            <div className='pl-5 pr-5'>
              <FormGroup>
                <Label for="title">Titulo de la noticia: </Label>
                <Input
                  placeholder="Ingrese el nuevo titulo"
                  type="text"
                  name="title"
                  value={this.state.title}
                  onChange={this.handleChange}
                  maxLength={100}/>
              </FormGroup>
              <FormGroup>
                <Label for="title">Información de la noticia: </Label>
                <Input
                  placeholder="Ingrese el nuevo texto"
                  type="textarea"
                  name="body"
                  value={this.state.body}
                  onChange={this.handleChange}
                  style={{height:'120px'}}
                  maxLength={500}
                />
              </FormGroup>
                <FormGroup action={''} method="post" encType="multipart/form-data">
                  <Label for="exampleFile">Seleccione una nueva imagen:</Label>
                  <Input type="file" name="file" id="exampleFile" onChange={this.addImage} ref="attachments"
                         onChange={this.addImage}/>
                </FormGroup>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={()=>this.edit(this.props.data.id)}>Guardar</Button>{' '}
            <Button color="danger" onClick={this.toggleEdit}>Cancelar</Button>
          </ModalFooter>
        </Modal>
        <div className='col-2 col-lg-1 news-del-icon'>
          <img src={edit} alt='' onClick={this.toggleEdit}/>
        </div>
        <Modal size={'lg'} isOpen={this.state.modalDelete} toggle={this.toggleDelete}>
          <ModalHeader className='header-modal'
                       toggle={this.toggleDelete}>Noticias</ModalHeader>
          <ModalBody>
            <h4>¿Esta seguro de que quiere eliminar "{this.props.data.title}"?</h4>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={()=>this.deleteNews(this.props.data.id)}>Aceptar</Button>{' '}
            <Button color="danger" onClick={this.toggleDelete}>Cancelar</Button>
          </ModalFooter>
        </Modal>
        <div className='col-1 col-lg-1 news-del-icon'>
          <img src={del} alt='' onClick={this.toggleDelete}/>
        </div>
      </div>
    );
  }

}

export default ListNews;



// WEBPACK FOOTER //
// ./src/components/listNews.js